define('GameDayCore/GDModel/enums/baseball/HotColdZoneColors',{
    hot			: "rgba(189, 104, 99, .55)",
	warm		: "rgba(208, 144, 139, .55)",
	cool		: "rgba(151, 172, 193, .55)",
	cold 		: "rgba(41, 91, 140, .55)",
    "default"	: "rgba(255, 255, 255, 0.55)"
});
